import { laravelPost } from '../utils/laravelClient';
import { ApiError } from '../utils/laravelError';

export async function verifyEmail(email, token) {
  return laravelPost('/loyalty/verify-email', { email, token }, { auth: 'none' });
}

export async function resendVerificationEmail(email) {
  try {
    return await laravelPost('/loyalty/resend-verification-email', { email }, { auth: 'none' });
  } catch (error) {
    if (error instanceof ApiError && error.status === 429) {
      throw new Error('Too many attempts. Please try again later.');
    }
    throw error;
  }
}

export async function resendVerificationEmailAuthenticated() {
  return laravelPost('/loyalty/send-verification-email', null, {
    auth: 'loyalty',
    context: { redirectOnFailure: false },
  });
}
